"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionPanel = exports.AccordionButton = exports.AccordionItem = exports.Accordion = void 0;
var Accordion_1 = __importDefault(require("./Accordion"));
exports.Accordion = Accordion_1.default;
var AccordionItem_1 = __importDefault(require("./AccordionItem"));
exports.AccordionItem = AccordionItem_1.default;
var AccordionButton_1 = __importDefault(require("./AccordionButton"));
exports.AccordionButton = AccordionButton_1.default;
var AccordionPanel_1 = __importDefault(require("./AccordionPanel"));
exports.AccordionPanel = AccordionPanel_1.default;
exports.default = { Accordion: Accordion_1.default, AccordionItem: AccordionItem_1.default, AccordionButton: AccordionButton_1.default, AccordionPanel: AccordionPanel_1.default };
